require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/react-bootstrap-components/~/core-js/library/fn/object/assign.js
// module id = 2130
// module chunks = 6